<template>
<div id="wizard" class="d-flex wrap position-relative w-100">
    <div v-if="!sending && !error && !success" class="w-100">
        <div v-for="(step, index) in steps" :key="step.id">
            <transition name="slide">
                <div class="card col-12 custom-card o-hidden border-0 my-4" v-if="shouldShow(step.slug, index) === true">
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div>
                            <div class="wizard-content pb-5">
                                <Category v-if="step.slug == 'category'" :tags="tags" :item="step" @selected="getData" />
                                <Location v-else-if="step.slug == 'location'" :item="step" :map="map" @selected="getData" />
                                <Screenshot v-else-if="step.slug == 'map_screenshot'" :item="step" />
                                <Formulaire v-else :item="step" @selected="getData" @validated="setValid(true)" @invalidated="setValid(false)" />
                            
                                <div class="row actions pt-3 pb-2" v-show="isBtnActionsShouldShow(index) === true">
                                    <div class="col">
                                        <button class="btn pl-0" v-show="index > 0" @click.prevent="emitDoPrev">
                                            <i class="fas fa-angle-left"></i>
                                        </button>
                                    </div>
                                    <div class="col text-right" v-show="index < steps.length-1">
                                        <button class="btn btn-primary btn-user font-weight-bold text-uppercase " @click.prevent="emitDoNext" :disabled="(mySteps && mySteps[index] && !mySteps[index].isValidated)">
                                            {{ $t("helper.next") }}
                                        </button>
                                    </div>
                                    <div class="col" v-show="index >= steps.length-1 && steps.length > 1">
                                        <button class="btn btn-primary btn-user btn-block" @click.prevent="sendData()" :disabled="(mySteps && mySteps[index] && !mySteps[index].isValidated)">
                                            {{ $t("helper.done") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="row actions" v-if="steps.length === 1">
                                    <div class="col">
                                        <button class="btn btn-primary btn-user btn-block" @click.prevent="sendData()" :disabled="(mySteps && mySteps[index] && !mySteps[index].isValidated)">
                                            {{ $t("helper.done") }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
    <template v-if="sending">
        <div class="card custom-card o-hidden border-0 my-4">
            <div class="card-body p-0">
                <div class="p-5">
                    <div class="text-center">
                        <h2 class="h2 text-gray-900 mb-4">Envoi en cours</h2>
                    </div>
                    <div class="text-center wizard-content">
                        <p>Enregistrement de la demande en cours. Ne fermez pas la page...</p>
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-if="sending === false && (error === true || success === true)">
        <div class="card custom-card o-hidden border-0 my-5 " style="z-index: 9999">
            <div class="card-body p-0">
                <div class="p-5">
                    <div class="text-center">
                    </div>
                    <div class="text-center wizard-content">
                        <template v-if="error"> Une erreur est survenue </template>
                        <template v-else>
                            <span class="check-icon bg-primary ">
                                <div class="bg-white">
                                    <i class="fas fa-check text-primary border"></i>
                                </div>
                                <span class="border-primary"></span>
                            </span>
                            <h2 class="h2 text-primary font-weight-bold text-uppercase mb-4">{{$t('wizard.thanks')}}</h2>
                            <p> Merci pour votre demande ! Un mail de notification va vous être envoyé avec la référence de cette demande. Vous recevrez une réponse à celle-ci, après traitement par nos services.
                            </p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </template>
</div>
</template>

<style scoped>
.actions {
    clear: both;
    position: fixed;
    width: 100%;
    z-index: 3;
    bottom: 0;
    left: 0;
    margin: 0;
    background: white;
}

.slide-leave-active,
.slide-enter-active {
    transition: 0.9s;
    position: absolute;
    z-index: 1;
}

.slide-enter {
    transform: translate(100%, 0);
    height: calc(100% - 3rem);
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.check-icon,
.check-icon div {
    border-radius: 50%;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
}

.check-icon {
    width: 50px;
    height: 50px;
    margin: 0 auto 15px;
}

.check-icon span.border-primary {
    position: absolute;
    left: 5px;
    top: 80%;
    width: 0;
    height: 0;
    border-left: 20px solid transparent !important;
    border-right: 20px solid transparent !important;
    border-top-style: solid !important;
    border-top-width: 25px !important;
    clear: both;

}

.check-icon div {
    width: 35px;
    height: 35px;
    z-index: 2;
}

.slide-leave-to {
    transform: translate(-120%, 0);
    padding-left: 1.5rem;
    padding-right: 1.5rem;

}
</style>

<script>
import Screenshot from '@/components/Form/WizardItem/Screenshot.vue'
import Category from '@/components/Form/WizardItem/Category.vue'
import Formulaire from '@/components/Form/WizardItem/Formulaire.vue'
import Location from '@/components/Form/WizardItem/Location.vue'
import {
    EventManager
} from '@/components/Events/EventManager.js'
import {
    APIService
} from '@/service/APIService.js'
export default {
    name: 'Wizard',
    props: ['tags', 'steps', 'map'],
    components: {
        Screenshot,
        Category,
        Formulaire,
        Location,
        EventManager,
        APIService
    },
    data: function () {
        return {
            current: 0,
            mySteps: [],
            post: {
                title: '', //'Signalement',
                content: '', //'default',
                prenom: '', //'default',
                nom: '', //'default',
                author_email: '', //'default',
                author_realname: '', //'default',
                values: {},
                media: {}
            },
            sending: false,
            error: false,
            success: false
        }
    },
    watch: {
        steps: function () {
            for (var i = 0; i < this.steps.length; i++) {
                var slug = this.steps[i].slug;
                var isValidated = false;
                this.mySteps.push({
                    'index': i,
                    'slug': slug,
                    'isValidated': isValidated
                });
            }
        }
    },
    created() {
        var that = this;

        APIService.setEndpoints(this.$store.state.vueAppBackendUrl, this.$store.state.vueAppModernApiUrl);

        EventManager.$on('do-next', function () {
            that.current++;
        });
        EventManager.$on('do-prev', function () {
            that.current--;
        });
        EventManager.$on('file-selected', function (data) {
            that.post.media = data;
        });
        EventManager.$on('go-to-step', function (step) {
            var shouldValidate = true;
            for (var i = 0; i < step; i++) {
                if (!that.mySteps[i].isValidated) {
                    shouldValidate = false;
                }
            }
            if (shouldValidate || step === 0) {
                that.current = step;
                EventManager.$emit('go-to-step-validate', step);
            }
        });
    },
    methods: {
        isBtnActionsShouldShow: function (index) {
            var step = this.steps[index];
            var shouldShow = true;
            if (step.slug == 'category') {
                if (step.attributes && step.attributes[0] && step.attributes[0].show_checkbox === 0) {
                    shouldShow = false;
                }
            }
            return shouldShow;
        },
        emitDoNext: function () {
            EventManager.$emit('do-next');
        },
        emitDoPrev: function () {
            EventManager.$emit('do-prev');
        },
        shouldShow: function (slug, index) {
            if (this.current == index) {
                if (slug == 'location') {
                    EventManager.$emit('redraw')
                }
                return true;
            }
            return false;
        },
        setValid: function (isValid) {
            var item = this.mySteps[this.current];
            item.isValidated = isValid;
            this.mySteps.splice(this.current, 1, item);
        },
        getData(data) {
            if (data.hasOwnProperty('wizard')) {
                var wizard = data.wizard;
                this.post[wizard] = data.content;
            }
            this.post.values[data.key] = [];
            if (typeof data.content === 'object') {
                this.post.values[data.key] = {};
                this.post.values[data.key] = data.content;
            } else {
                this.post.values[data.key].push(data.content);
            }
            if (['category', 'location'].indexOf(this.mySteps[this.current].slug) >= 0) {
                this.setValid(true);
            }
            this.$store.commit("setPost", this.post);
        },
        async recaptcha() {
            await this.$recaptchaLoaded()
            const token = await this.$recaptcha('sendPost');
            var that = this;            
            APIService.verifyRecaptcha({
                '_recaptcha': token
            }, function (response) {
                if (response.data.verify === true) {
                    that.sendData();
                }
            }, function (error) {
                console.log(error);
            });
        },
        sendData: function () {
            var shouldBreak = false;
            for (var i = 0; i < this.mySteps.length; i++) {
                if (!this.mySteps[i].isValidated) {
                    this.current = i;
                    shouldBreak = true;
                }
            }
            if (shouldBreak) {
                EventManager.$emit('do-toast', "Vous n'avez pas valider l'étape");
            } else {
                this.sending = true;
                this.post.author_realname = this.post.prenom + ' ' + this.post.nom;
                this.post.content = this.post.description;
                this.post.author_email = this.post.email;

                var loggedUser = this.$store.state.user;

                if(loggedUser && loggedUser.hasOwnProperty('id')){
                    this.post.user_id = loggedUser.id
                } 

                if (this.$store.state.isAnonymous == true) {
                    this.post.author_realname = 'ANONYME';
                    this.post.author_email = 'ANONYME@ANONYME.fr';
                }
                this.post.form = {
                    'id': this.$store.state.formId
                };
                if (this.post.media && this.post.media.content) {
                    var formData = new FormData();
                    var keys = Object.keys(this.post.media.content);
                    for (var i = 0; i < keys.length; i++) {
                        var key = 'file[' + i + ']';
                        var value = this.post.media.content[i];
                        formData.append(key, value);
                    }
                    var that = this;
                    APIService.uploadMedia(formData, function (response) {
                        var tab = response.data;
                        that.post.values[that.post.media.key] = [];
                        for (var i = 0; i < tab.length; i++) {
                            that.post.values[that.post.media.key].push(tab[i].id);
                        }
                        that.sendAPIQuery();
                    }, function (error) {
                        that.sending = false;
                        that.success = false;
                        that.error = true;
                    });
                } else {
                    this.sendAPIQuery();
                }
            }
        },
        sendAPIQuery: function () {
            var that = this;

            var data = {
                data: JSON.stringify(this.post)
            }

            var token = this.$store.state.token;
            if(token && token.length > 0){
                data.token = token
            }

            APIService.savePost(data, function (response) {
                var redirect = that.$store.state.redirect;
                if (redirect.length > 0) {
                    window.location.href = redirect;
                } else {
                    that.sending = false;
                    that.success = true;
                    that.error = false;
                }
            }, function (error) {
                console.log(error)
                that.sending = false;
                that.success = false;
                that.error = true;
            });
        }
    },
    mounted() {}
}
</script>
